import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar.js";
import { TopBar } from "./TopBar.js";
import { cn } from "@/lib/cn.js";

export function AppShell(): JSX.Element {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    const saved = window.sessionStorage.getItem("sidebar-collapsed");
    if (saved !== null) return saved === "1";
    // Mobile-first: su schermi stretti parte col rail icone (64px), non con la
    // sidebar piena che schiaccerebbe il contenuto a ~150px.
    return window.innerWidth < 768;
  });

  function toggle() {
    setCollapsed((v) => {
      const next = !v;
      window.sessionStorage.setItem("sidebar-collapsed", next ? "1" : "0");
      return next;
    });
  }

  return (
    <div className="dot-grid min-h-screen bg-bg text-ink">
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      {/* Su mobile il padding resta al rail (64px): la sidebar espansa si
          sovrappone come drawer (è già fixed) invece di comprimere il contenuto. */}
      <div className={cn("pl-[64px] transition-[padding] duration-220 ease-out-quart", !collapsed && "md:pl-[240px]")}>
        <TopBar />
        <main className="mx-auto w-full max-w-canvas px-4 py-6 md:px-9 md:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
